import axios from "axios";
import http from "./HttpCommon";

class DashboardService {
  onLogin(data) {
    return http.post("NewLogin/withOutAd/", data);
  }

  callToken = async (data) => {
    try {
      const configurationObject = {
        method: "POST",
        url: process.env.REACT_APP_BASEURL + "gcp/backofficenew/oauth/token",
        data: data,
      };
      const response = await axios(configurationObject);
      return response;
    } catch (error) {
      return error.response;
    }
  };
}


const dashboardService = new DashboardService();
export default dashboardService;
